export default {
    personalInfo: null,
    //结算信息
    billingInfo: null,
    //企业信息
    companyInfo: null,
    //法人信息
    corporatePersonInfo: null,
    //退款信息
    refundInfo: null,
    //服务商列表
    parentCompanyLists: null,
    //渠道商列表
    subCompanyLists: null,
    //根据用户名或邀请码查询的服务商
    parentCompanyBySearch: null,
    //增票资质
    vatInfo:null,
    //增票资质详情
    vatDetail: {
        id: null, // 新增时后端需要传null
        name: '',
        taxpayerNumber: '',
        registeredPhone: '',
        registeredAddress: '',
        bankName: '',
        bankAccount: '',
        taxBoard: '',
        taxpayerForm: ''
    },
    //公司名称和纳税人识别码
    agencyInfo: null,
    //卖家一级品类
    sellerFirstCategories: [],
    //开通卖家选择的售卖品类
    selectedCategoryList: [{},{},{}]
}


// WEBPACK FOOTER //
// ./src/store/personal-center/state.js